import { COMMENTS_BASE_URL } from 'Frontend/constants/endpoint'
import { CommentCollectionItem, CommentId } from '../models/communityNews.model'
import { IAntiforgeryToken } from '../models/general.model'
import { getAntiforgeryToken } from './general.service'

export async function getComments(contentId: number): Promise<CommentCollectionItem> {
  let response = await fetch(`${COMMENTS_BASE_URL}/getcomments?contentId=${contentId}`)
  const jsonResults = await response.json()
  return <CommentCollectionItem>jsonResults
}

export async function createComment(contentId: number, comment: string): Promise<boolean> {
  const { csrfToken }: IAntiforgeryToken = await getAntiforgeryToken()

  const commentPostBody = JSON.stringify({
    ContentId: contentId,
    Comment: comment,
  })

  let response = await fetch(`${COMMENTS_BASE_URL}/createcomment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': csrfToken,
    },
    body: commentPostBody,
  })

  return response.ok
}

export async function deleteComment(commentId: CommentId): Promise<Boolean> {
  const { csrfToken }: IAntiforgeryToken = await getAntiforgeryToken()

  await fetch(`${COMMENTS_BASE_URL}/deletecomment?commentId=${commentId.storeId}:${commentId.externalId}`, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-TOKEN': csrfToken,
    },
  })

  return true
}
